import { createFileRoute } from '@tanstack/react-router';
import {
  PERMISSION_ONLINE_MAP_TEMPLATES_CUSTOMER,
  PERMISSION_ONLINE_MAP_TEMPLATES_PRIVATE,
  PERMISSION_ONLINE_MAP_TEMPLATES_SYSTEM,
} from '../../Services/PermissionsService';
import { requirePermissions } from '../../router/RouteGuardsService';
import OnlinePanel from '../../components/OnlinePanel';

export const Route = createFileRoute('/_authenticated/online_panel/templates/edit/$id')({
  beforeLoad: async ({ context }) => {
    await requirePermissions(
      [
        PERMISSION_ONLINE_MAP_TEMPLATES_CUSTOMER,
        PERMISSION_ONLINE_MAP_TEMPLATES_PRIVATE,
        PERMISSION_ONLINE_MAP_TEMPLATES_SYSTEM,
      ],
      ['read'],
      '/unauthorized',
      context
    );
    return {
      ...context,
      documentTitle: {
        main: 'onlineTemplates.subPage.edit.subtitle',
        suffix: 'menu.onlinePanel',
      },
    };
  },
  // Modal opened by the OnlinePanel list based on the URL.
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RouteView,
});

function RouteView() {
  const { id } = Route.useParams();

  return <OnlinePanel mode="edit" editId={Number(id)} />;
}
